import authTypes from './authTypes.js'
import checklistsTypes from './checklistsTypes'
import filterTypes from './filterTypes'

const types = {
  ...authTypes,
  ...checklistsTypes,
  ...filterTypes,
}

export default types